import React from "react";
import { Box, Grid } from "@mui/material";
export default function LinearGradientBox({ color }: { color: string }) {
  return (
    <Grid
      item
      xs={14}
      sm={4}
      md={4}
      lg={3}
      xl={2}
      width={"100%"}
      height={"100%"}
    >
      <Box
        className="carousel-cards"
        sx={{
          width: "130px",
          height: "75px",
          borderRadius: "5px",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
          position: "relative",
        }}
        style={{
          background: `linear-gradient(160deg,rgba(255,255,255,.85), ${color})`,
        }}
      ></Box>
    </Grid>
  );
}
